<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-sale-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-sale"></div>
                <div class="dialog-body">
                    <div class="buy-detail">
                        <ul class="sale-list">
                            <li class="clearfix"><em class="f-l">商品总价</em><p class="f-r">{{ settle.total }}<em class="icon-m3b"></em></p></li>
                            <li class="clearfix"><em class="f-l">砍价已减</em><p class="f-r">{{ settle.share }}<em class="icon-m3b"></em></p></li>
                            <li v-if="settle.discount.type1 > 0" class="clearfix"><em class="f-l">每满2000b减200b满减</em><p class="f-r">{{ settle.discount.type1 }}<em class="icon-m3b"></em></p></li>
                            <li v-if="settle.discount.type2 > 0" class="clearfix"><em class="f-l">每满5000b减600b满减</em><p class="f-r">{{ settle.discount.type2 }}<em class="icon-m3b"></em></p></li>
                            <li v-if="settle.offer > 0" class="clearfix"><p class="f-l">店铺优惠券<em class="shop-ticket"></em></p><p class="f-r">{{ settle.offer }}<em class="icon-m3b"></em></p></li>
                        </ul>
                        <div class="total clearfix">
                        <em class="f-l">合计</em>
                        <p class="f-r">           
                            {{ settle.bill }}<em class="icon-m3b"></em>
                        </p></div>
                    </div>
                </div>          
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>     
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            settle : () => {},
        }
    },
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },     
    },      
}
</script>

<style scoped>
/* sale */
.m-sale-modal {
    width: 579px;
    height: 423px;
    background-image: url(~@/assets/images/utils/modal-buy.png);
}

.t-sale {
    width: 293px;
    height: 52px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-sale.png);
}

.m-sale-modal .buy-detail ul.sale-list {
    padding: 12px 24px 0;
    background-color: #e6bf85;
}

.m-sale-modal ul.sale-list li {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px dashed #d7b078;
}

.total{
    padding: 0 24px;
}

</style>


// WEBPACK FOOTER //
// src/components/SaleDetailModal/saleDetailModal.vue